import { Navigate } from "react-router-dom";

import { PermissionsAction } from "@/common/types/permissions.types";

interface PrivateRouteProps {
  children: React.ReactNode;
  permissionScope?: { [module: string]: string[] };
  module: string;
  action: string | string[];
}

function PrivateRoute({
  children,
  permissionScope,
  module,
  action
}: PrivateRouteProps) {
  if (
    permissionScope?.[module]?.some(currentAction => {
      if (currentAction === PermissionsAction.ALL) {
        return true;
      }

      if (Array.isArray(action)) {
        return action.includes(currentAction);
      }

      return action === currentAction;
    })
  ) {
    return <>{children}</>;
  }

  return <Navigate to="/" replace />;
}

export default PrivateRoute;
